import { ApiClient } from '@api/ApiClient'

export interface IPricing {
    variableInterest: number,
    fixedInterest: number,
    dealerCommitmentCommissionMin: number,
    dealerCommitmentCommissionPct: number,
    documentFee: number,
    agreementId?: number | null,
}

export interface IAgreementInfo {
    id: number,
    code: number,
    name: string,
}

export class OwnPricingApiClient{
    constructor(protected apiClient: ApiClient) { }

    public getAgreementPricing(dealerId: number, agreementType: 'purchase' | 'unsecure' | 'leasing'){
        return this.apiClient.get<IPricing>(`api/dealers/${dealerId}/own-pricing/${agreementType}/`).then(x => x.data)
    }

    public deleteAgreementPricing(dealerId: number, agreementType: 'purchase' | 'unsecure'| 'leasing' ){
        return this.apiClient.delete<IPricing>(`api/dealers/${dealerId}/own-pricing/${agreementType}/`)
    }

    public updateAgreementPricing(dealerId: number, agreementType: 'purchase' | 'unsecure' | 'leasing', pricing: IPricing){
        return this.apiClient.post<IPricing>(`api/dealers/${dealerId}/own-pricing/${agreementType}/`, pricing)
    }

    public getDealerPurchaseAgreements(dealerId: number){
        return this.apiClient.get<IAgreementInfo[]>(`api/dealers/${dealerId}/own-pricing/purchase/agreements`).then(x => x.data)
    }

    public getAgreementPricingByAgreementId(dealerId: number, agreementId: number){
        return this.apiClient.get<IPricing>(`api/dealers/${dealerId}/own-pricing/purchase/agreements/${agreementId}`).then(x => x.data)
    }

    public updateAgreementPricingByAgreementId(dealerId: number, agreementId: number, pricing: IPricing){
        return this.apiClient.post<IPricing>(`api/dealers/${dealerId}/own-pricing/purchase/agreements/${agreementId}`, pricing)
    }

    public deleteAgreementPricingByAgreementId(dealerId: number, agreementId: number){
        return this.apiClient.delete(`api/dealers/${dealerId}/own-pricing/purchase/agreements/${agreementId}`)
    }
}
